import {createClient} from 'contentful';

// Contentful configuration --
const SPACE_ID = "nccgni4s18at";
const ACCESS_TOKEN = "927e1912c98738dafbc5d4e7689642088374c9608c8691065b30fc8f06cb6dec";
const PREVIEW_ACCESS_TOKEN = "972600d3404932c13eb24287894497ed05dbf98b7d06bec32adb9d5d2d44857e";

// Test if we need to preview...
const domain = window.location.host.split('.')[0];
const isStaging = domain === 'preview' || domain === 'localhost:5000';

// Client...
const clientOptions = isStaging ? {
  space: SPACE_ID,
  accessToken: PREVIEW_ACCESS_TOKEN,
  host: 'preview.contentful.com',
  removeUnresolved: true
} : {
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  removeUnresolved: true
};
const Client = createClient(clientOptions);

export default Client;



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Client.js